import { listMessages } from '@/lib/api/sessions.client';
import type { IMessage } from '@/lib/types/chat';
import { mapChatMessages } from '@/lib/stores/chat-store/message-dto';

/**
 * Reading a chat's stored messages (KAN-1266): the one way every caller does
 * it, the chat store opening a chat as much as the chat runtime getting back
 * in step with the database.
 */

/** How many messages a chat is read with: in practice, all of them. */
const WHOLE_CHAT_LIMIT = 1000;

/**
 * The session's stored messages as the chat shows them (``mapChatMessages``:
 * hidden ones dropped, in reading order). Throws whatever the read throws;
 * each caller decides what a failed read means for it.
 */
export async function fetchPersisted(
  sessionId: string,
  limit: number = WHOLE_CHAT_LIMIT
): Promise<IMessage[]> {
  return mapChatMessages(await listMessages(sessionId, { limit, offset: 0 }));
}
